module.exports = __webpack_public_path__ + "static/media/union_happy-hour.0e93ebbc.jpg";